import type { ProviderName } from '../types';

export function buildGrantUrl(path: string, providerName: ProviderName, scopes: string[]) {
  const url = new URL(path, window.location.origin);

  url.searchParams.append('provider_name', providerName);

  for (const scope of scopes) {
    url.searchParams.append('scopes[]', scope);
  }

  return url;
}
